import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";

import { Button, Form, Input, Tabs } from "antd";

import { changePassword } from "../../api";
import { commonUtil } from "../../utils";
import { ValidationForm } from "../../common/interfaces";

interface Props {
  phone: string;
  email: string;
}

const ChangePassword: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [newPass, setNewPass] = useState<string>("");
  const [reNewPass, setReNewPass] = useState<string>("");
  const [currentPass, setCurrentPass] = useState<string>("");
  const [validateCurrentPass, setValidateCurrentPass] =
    useState<ValidationForm | null>(null);
  const [validateNewPass, setValidateNewPass] = useState<ValidationForm | null>(
    null
  );
  const [validateReNewPass, setValidateReNewPass] =
    useState<ValidationForm | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const auth = useAuth();
  const history = useHistory();

  // handle change current password
  const onChangeCurrentPass = (value: string) => {
    setCurrentPass(value.trim());
    setValidateCurrentPass(null);
  };

  const onChangeNewPass = (value: string) => {
    setNewPass(value.trim());
    setValidateNewPass(null);
  };

  const onChangeReNewPass = (value: string) => {
    setReNewPass(value.trim());
    setValidateReNewPass(null);
  };

  // validate current password: if right => next step2
  const confirmChangePassword = async () => {
    if (!currentPass) {
      setValidateCurrentPass({
        status: "error",
        text: t("notification:Vui lòng nhập mật khẩu hiện tại"),
      });
      return;
    }
    if (currentPass.length < 8) {
      setValidateCurrentPass({
        status: "error",
        text: t("notification:Mật khẩu phải có ít nhất 8 ký tự"),
      });
      return;
    }
    if (!newPass) {
      setValidateNewPass({
        status: "error",
        text: t("notification:Vui lòng nhập mật khẩu mới"),
      });
      return;
    }
    if (newPass && !commonUtil.isPasswordValid(newPass)) {
      setValidateNewPass({
        status: "error",
        text: t("notification:Mật khẩu không đúng định dạng"),
      });
      return false;
    }
    if (newPass.length < 8) {
      setValidateNewPass({
        status: "error",
        text: t("notification:Mật khẩu phải có ít nhất 8 ký tự"),
      });
      return;
    }
    if (newPass === currentPass) {
      setValidateNewPass({
        status: "error",
        text: t("notification:Mật khẩu mới phải khác mật khẩu cũ"),
      });
      return;
    }
    if (!reNewPass) {
      setValidateReNewPass({
        status: "error",
        text: t("notification:Vui lòng nhập lại mật khẩu mới"),
      });
      return;
    }
    if (reNewPass.length < 8) {
      setValidateReNewPass({
        status: "error",
        text: t("notification:Mật khẩu phải có ít nhất 8 ký tự"),
      });
      return;
    }
    if (newPass !== reNewPass) {
      setValidateReNewPass({
        status: "error",
        text: t("notification:Mật khẩu không khớp"),
      });
      return;
    }
    try {
      setIsLoading(true);
      const res = await changePassword({
        oldPassword: currentPass,
        newPassword: newPass,
      });
      setIsLoading(false);
      setValidateCurrentPass(null);
      setValidateNewPass(null);
      setValidateReNewPass(null);
      if (res.status === "error") {
        commonUtil.showMessage("error", res.message);
        return;
      } else {
        setCurrentPass("");
        setNewPass("");
        setReNewPass("");
        commonUtil.showMessage(
          "success",
          t("notification:Thay đổi mật khẩu thành công")
        );
        commonUtil.deleteSession();
        auth.logout();
        history.push("/login");
        return;
      }
    } catch (e) {
      setIsLoading(false);
      throw e;
    }
  };
  return (
    <Tabs
      defaultActiveKey="1"
      className="mb-40 md:mb-60 shadow"
      style={{
        borderRadius: "8px",
        padding: "0 16px 16px 16px",
        backgroundColor: "white",
        overflow: "hidden",
      }}
    >
      <Tabs.TabPane tab={t("common:Mật khẩu")} key="1">
        <p className="mb-8" style={{ fontWeight: 600 }}>
          {t("common:Sử dụng mật khẩu cũ để thay đổi")}
        </p>
        <div>
          <Form.Item
            validateStatus={validateCurrentPass?.status}
            help={validateCurrentPass?.text}
          >
            <Input.Password
              placeholder={t("common:Mật khẩu hiện tại")}
              value={currentPass}
              onChange={(event) => onChangeCurrentPass(event.target.value)}
            />
          </Form.Item>
          <Form.Item
            validateStatus={validateNewPass?.status}
            help={validateNewPass?.text}
          >
            <Input.Password
              placeholder={t("common:Mật khẩu mới")}
              value={newPass}
              onChange={(event) => onChangeNewPass(event.target.value)}
            />
          </Form.Item>

          <Form.Item
            validateStatus={validateReNewPass?.status}
            help={validateReNewPass?.text}
          >
            <Input.Password
              placeholder={t("common:Nhập lại mật khẩu mới")}
              value={reNewPass}
              onChange={(event) => onChangeReNewPass(event.target.value)}
            />
          </Form.Item>
        </div>

        <div style={{ textAlign: "center" }}>
          <Button
            type={"primary"}
            loading={isLoading}
            onClick={confirmChangePassword}
          >
            <span>{t("common:Đổi mật khẩu")}</span>
          </Button>
        </div>
      </Tabs.TabPane>
    </Tabs>
  );
};

export default ChangePassword;
